
import Vuex from "vuex";
import Vue from "vue";
import data from "./modules/data";
import mainViz from './modules/main-viz';
import upload from "./modules/upload";
import audio from "./modules/audio";

Vue.use (Vuex);

export default new Vuex.Store ({
  modules: {
    data,
    mainViz,
    upload,
    audio
  },
});
